import { hasRole } from '@court-sync/shared';
import { useAuthStore } from '@/store/auth';

/**
 * UI-only approximation of the backend's `requireClubOwnerOnly` check (business rules section 14:
 * club_admin is excluded from club payments/financials). Academy owners are treated as club owners
 * for the internal club shell, and platform admins manage everything. This only hides controls for
 * a better experience — the backend is the source of truth and rejects `club_admin` regardless.
 */
export function useClubOwnerAccess(): { canManageClubPayments: boolean } {
  const { user } = useAuthStore();
  const canManageClubPayments =
    hasRole(user, 'club_owner') || hasRole(user, 'academy_owner') || hasRole(user, 'admin');
  return { canManageClubPayments };
}
